<div class="container background-logout">
  <div class="logo">
    <img src="assets/images/png/logo_finastra.png" alt="Finstra company logo">
  </div>
  <div class="box">
    <div class="box-container">
    <div class="logo-box">
      <img src="assets/images/png/logo_finastra.png" alt="Finstra company logo">
    </div>
    <span><b>Payments To Go</b></span>
    <div class="space"></div>
    <span>You have been successfully logged out</span>
    <button mat-raised-button  color="primary" (click)="goToLogin()">Login Again</button>
  </div>
  </div>
</div>
